export default {
	methods: {
		//매 3자리 수 마다 , 를찍어주는 함수
		returnCommas(x = 0) {
			return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
		},
	}
}
